import { Typography, TypographyProps, useTheme } from '@mui/material';
import reactStringReplace from 'react-string-replace';

export function PhraseHighlight({ phrase, highlight, underline = true, sx = [], ...props }: { phrase: string; highlight?: string; underline?: boolean } & TypographyProps) {
    const theme = useTheme();

    return (
        <Typography variant='h4' textAlign={'center'} noWrap sx={[...(Array.isArray(sx) ? sx : [sx])]} {...props}>
            {reactStringReplace(phrase, highlight || '', (match, i) => (
                <span key={i} style={{ color: (theme.vars || theme).palette.primary.main, textDecoration: underline ? 'underline' : undefined }}>
                    {match}
                </span>
            ))}
        </Typography>
    );
}
